import Vue from 'vue'
import Vuex from 'vuex'
import axios from 'axios';

Vue.use(Vuex)


axios.interceptors.request.use(config => {
  store.commit('setLoader', true)
  return config
});

axios.interceptors.response.use(response => {
    setTimeout(() => {
        store.commit('setLoader', false)
    },600)
  return response
})


export const store = new Vuex.Store({
    state: {
        apiUrl: "https://webapi.porscheinterauto.com.pl/",
        loader: false,
        offers:{},
        request: {
            // url_brand: 'audi',
            // url_model:'',
            model_id: '',
            limit: 70,
            page: 1,
            brand_id: 9,
            order: 0,
            city_names:[
              'Poznań'
            ],
            vins:[
              "WAUZZZF47KA039772",
              "WAUZZZF46KA039276",
              "WAUZZZFY3K2056193",
              "WAUZZZF21KN068627",
              "WAUZZZF27KN069989",
              "WAUZZZFY6K2131131",
              "WAUZZZFY7K2086247",
              "WAUZZZF24LN036160",
              "WAUZZZ4M5KD035110",
              "WAUZZZF25KN120521",
              "WAUZZZF23KN024435"
            ]
            // url_params: [
            //     'c-poznan',
            //     'yf2018',
            //     'yt2019',
            //     'ty1',
            //     'pi16928',
            //     'pi17957',
            //     'pi17443',
            //     'pi18401',
            //     'pi18394',
            //     'pi15509',
            //     'pi16050',
            //     'pi15021',
            //     'pi18415',
            //     'pi19384',
            //     'pi15020',
            //     'pi16690',
            //     'pi18779',
            //     'pi19035',
            //     'pi13315',
            //     'pi16357',
            //     'pi16316'
            // ]
        },
        selectedOffer:false
    },
    getters: {
        getOffers: state => {
            return state.offers;
        },
        getCurrentModel: state => {
            // return state.request.url_model.replace(",", "");
        },
        getLoader: state => {
            return state.loader;
        },
        getSelectedOffer: state => {
            return state.selectedOffer;
        }
    },
    mutations: {
        setOffers: function(state, newState) {
            state.offers = newState;
        },
        setLoader: function(state, newState){
            state.loader = newState;
        },
        setModel: function (state, newState) {
            state.request.limit = 200;
            state.request.model_id = newState+',';
        },
        setSelectedOffer: function (state, newState) {
            state.selectedOffer = newState;
        }
    },
    actions:{
        async downloadOffers({ commit, state }) {
            // var request = {
            //   ...state.request
            // };
            // request.url_params = request.url_params.join(',')
            const { data } = await axios.get(state.apiUrl+'cars', {
                params: state.request
            });
            commit('setOffers', data);
        },
        downloadModel({dispatch,commit}, payload) {
            commit('setModel', payload);
            dispatch('downloadOffers');
        }
    }

})
